import { StringManager } from '@payments-checkout/shared/helpers/managers/string.manager';
import { mundipaggInstance } from '@payments-checkout/shared/helpers/service/mundipagg.service';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';

type CepResponse = {
  street: string;
  district: string;
  zip_code: string;
  city: string;
  state: string;
  country: string;
};

 const getAddress = async (cep: string) => {
  if (!cep) throw new Error('Cep is required');

  const response = await mundipaggInstance.get<CepResponse>(
    `/maps/v1.0/BR/${cep}`
  );
  return response;
};

const useAddress = (cep?: string) => {
  const query = useQuery<AxiosResponse<CepResponse>, AxiosError>({
    queryKey: ['useAddress', cep],
    queryFn: async () => getAddress(StringManager.onlyNumbers(cep || '0')),
    refetchOnWindowFocus: false,
    staleTime: 0,
    retry: false,
    enabled: false,
  });

  return { ...query, data: query.data?.data };
};

export { getAddress, useAddress };

